import { j as i } from "../../../../../node_modules/react/jsx-runtime.js";
import { memo as n, useCallback as p } from "react";
import { clsx as b } from "../../../../../node_modules/clsx/dist/clsx.m.js";
import d from "../../Table.module.scss.js";
const f = ({
  children: r,
  active: s,
  disabled: a,
  onClick: t,
  className: e,
  key: l,
  ref: m
}) => {
  const c = p(
    (o) => {
      t && t(o);
    },
    [t]
  );
  return /* @__PURE__ */ i.jsx(
    "tr",
    {
      className: b(d.table_tr, e, {
        "bg-color-bg-base-pressed": s,
        "cursor-not-allowed": a
      }),
      onClick: (o) => c(o),
      "data-testid": "table-row",
      ref: m,
      children: r
    },
    l
  );
}, R = n(f);
export {
  R as default
};
//# sourceMappingURL=DataRow.js.map
